<template>
  <b-modal
    hide-footer
    id="modal-law-consult"
    ref="modal-law-consult"
    size="md"
    title="คำปรึกษาจากเจ้าหน้าที่"
  >
    <div class="container">
      <b-card>
        <b-row>
          <b-col cols="12" class="mb-2">
            <h3>
              <span>คำปรึกษาจากเจ้าหน้าที่</span>
            </h3>
          </b-col>
          <b-col cols="12">
            <p>
              {{lawConsult.detail}}
            </p>
          </b-col>
        </b-row>
        
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import * as storeLawConsult from "@/store/api/lawConsult/index.js";



export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
  },
  props: {},
  data() {
    return {
      fullname: "",
      lawConsult: {
        detail: '',
      },
    };
  },
  created() {},
  mounted() {
    //console.log("modal mounted");
  },
  methods: {
    onShow(id) {
      const _this = this
      storeLawConsult.getByDocId(id).then((response) => {
        _this.lawConsult = response.data.data
      })
    },
  },
};
</script>

<style></style>
